import React from 'react'
import { AEMLinkProperties } from '@components/Form/FormTypes'

interface CountdownTeaserButtonProperties {
  ctaLabel: string
  ctaLink: AEMLinkProperties
  className?: string
}

const CountdownTeaserButton: React.FC<CountdownTeaserButtonProperties> = ({
  ctaLabel,
  ctaLink,
  className,
}: CountdownTeaserButtonProperties) => {
  if (!ctaLink || !ctaLink.externalizedURL) {
    return null
  }
  return (
    <a
      className={className || 'cmp-countdown-teaser__button'}
      href={ctaLink.externalizedURL}
      target={ctaLink.isTargertBlank ? '_blank' : ''}
      rel={ctaLink.htmlAttributes?.rel}
    >
      {ctaLabel}
    </a>
  )
}

export default CountdownTeaserButton
